export function formatNumber(n: number): string {
  if (n >= 10000) {
    return `${(n / 10000).toFixed(1)}万`;
  }
  if (n >= 1000) {
    return `${(n / 1000).toFixed(1)}k`;
  }
  return String(n);
}

export const heatBadgeClass: Record<string, string> = {
  爆: "bg-primary-500 text-white",
  热: "bg-accent-500 text-foreground-950",
  "发酵中": "bg-secondary-400 text-white",
};

export const toneClass: Record<string, string> = {
  agree: "text-accent-700 bg-accent-100",
  neutral: "text-secondary-700 bg-secondary-100",
  against: "text-primary-700 bg-primary-100",
};

export const toneText: Record<string, string> = {
  agree: "赞同",
  neutral: "中立",
  against: "反对",
};